import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { WarningAmberOutlined, Google, PaletteOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  Center,
  Container,
  Group,
  LoadingOverlay,
  Select,
  Space,
  Stack,
  Switch,
  Text,
  TextInput,
  useMantineTheme,
} from "@mantine/core";
import { GoogleIcon } from "src/components/common/Icons/GoogleIcon";
import { useAppDispatch, useAppSelector } from "src/redux/redux-store/hooks";
import { authService } from "src/services/services/auth/auth.api";
import { ResponseKind } from "src/services/services/MainService";
import useAdminSettings from "src/hooks/useAdminSettings";
import { StyledContainer } from "src/components/common/StyledComponents/Container";
import { FeedbackComponent } from "src/components/common/Feedback";
import { COLORS, FONT_SIZES } from "src/utils/styles";
import { StyledContainerInset } from "src/components/common/StyledComponents/BackgroundContainer";
import useResponsive from "src/hooks/useResponsive";
import { FocusButton } from "src/components/common/Buttons/FocusButton";
import { updateDisclaimers } from "src/redux/redux-store";

const OtherSettings: FunctionComponent = () => {
  const theme = useMantineTheme();
  const dispatch = useAppDispatch()
  const { adminSettings, enableGDrive, loading, feedback, error, updateDisclaimer } =
    useAdminSettings();

  const [parentdisclaimers, setParentDisclaimers] = useState(adminSettings?.parent_disclaimers)
  const [childDisclaimers, setChildDisclaimers] = useState(adminSettings?.child_disclaimers)
  const { backgroundColor, backgroundColorExterior, isMobile } = useResponsive()

  useEffect(() => {
    setChildDisclaimers(adminSettings?.child_disclaimers)
    setParentDisclaimers(adminSettings?.parent_disclaimers)
  }, [adminSettings?.child_disclaimers, adminSettings?.parent_disclaimers])

  return (
    <StyledContainer theme={{ backgroundColor: backgroundColorExterior }}>
      <StyledContainerInset theme={{ backgroundColor: backgroundColor }}>
        <div className="p-4 h-[100%] overflow-y-auto">
          <LoadingOverlay visible={loading} />
          <Text size={FONT_SIZES.h1} fw={600}>
            Other Settings
          </Text>
          <Text c="dimmed" size={14}>
            Update disclaimers and logo, put on maintenance notice and trigger
            google drive file import feature.
          </Text>

          <Card w={"100%"} bg={backgroundColor} withBorder my={"md"}>
            <TextInput
              styles={(theme) => ({
                input: {
                  marginTop: theme.spacing.xs,
                },
              })}
              placeholder="XXXXX"
              onChange={(event) => setChildDisclaimers(event.currentTarget.value)}
              value={childDisclaimers}
              label="Child Disclaimer"
            />

            <TextInput
              styles={(theme) => ({
                input: {
                  marginTop: theme.spacing.xs,
                },
                root: {
                  marginTop: theme.spacing.md
                }
              })}
              placeholder="XXXXX"
              onChange={(event) => setParentDisclaimers(event.currentTarget.value)}
              value={parentdisclaimers}
              label="Parent Disclaimer"
            />
            <Stack maw={"100%"} my={"md"}>
              <FocusButton
                iconSize="1.25rem"
                textSize={FONT_SIZES.h3}
                icon="save"
                text="Update Disclaimers"
                onClick={() => updateDisclaimer(childDisclaimers, parentdisclaimers, () => {
                  dispatch(updateDisclaimers(childDisclaimers, parentdisclaimers));
                })}
              />
              {/* <FocusButton 
        iconSize="1.25rem"
        textSize={FONT_SIZES.h3}
        icon="paletteOutlined"
        text="Change Logo"
        /> */}
            </Stack>

            <Card withBorder>
              <Group position="apart">
                <Group>
                  <WarningAmberOutlined fontSize={"small"} />
                  <Text size={"sm"}>Maintainence Notice</Text>
                </Group>
                <Switch readOnly />
              </Group>

              {/* <Group mt={"sm"} position="apart">
            <Group>
              <Google fontSize={"small"} />
              <Text size={"sm"}>File Import From Google Drive</Text>
            </Group>
            <Switch onChange={(e) => enableGDrive(e.currentTarget.checked)} checked={adminSettings.gdrive_enabled} />
          </Group> */}
              {/* <Group position="apart">
              <Group>
                <MailRounded />
                <Text>Maintainence Notice</Text>
              </Group>

              <Switch 
              readOnly
                  // onChange={(e) => enableGDrive(e.currentTarget.checked)}
                  // checked={adminSettings.}
              />
            </Group>

            <Group mt={"sm"} position="apart">
              <Group>
                <GoogleIcon />
                <Text>File Import From Google Drive</Text>
              </Group>

              <Switch
                onChange={(e) => enableGDrive(e.currentTarget.checked)}
                checked={adminSettings.gdrive_enabled}
              />
            </Group> */}
            </Card>
          </Card>
          {feedback ? (
            <FeedbackComponent
              error={error}
              feedback={feedback}
            />
          ) : null}
        </div>
      </StyledContainerInset>
    </StyledContainer>
  );
};

export default OtherSettings;
